import { render } from "./CreatorFaqMainContent.vue?vue&type=template&id=9bd7fedc&scoped=true"
import script from "./CreatorFaqMainContent.vue?vue&type=script&lang=js"
export * from "./CreatorFaqMainContent.vue?vue&type=script&lang=js"

import "./CreatorFaqMainContent.vue?vue&type=style&index=0&id=9bd7fedc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd7fedc"]])

export default __exports__